import { Box, Button, Typography, styled } from '@mui/material';

import TisSrc from '@common/assets/icons/TIS.svg';
import CanadaBackground from '@common/assets/images/canada.webp';

export const StyledGradeBookLessonTisImage = styled(TisSrc)({
	width: '41px',
	height: '36px',
	marginRight: '8px',
	cursor: 'pointer',
});

export const StyledGradeBookLessonArrowWrap = styled(Button)({
	padding: '8px',
	borderRadius: '4px',
	height: 'auto',
});

export const StyledGradeBookLessonMiroButton = styled(Button)(({ theme }) => ({
	padding: '8px',
	borderRadius: '4px',
	background: theme.palette.warning.main,
	height: 'auto',
}));

export const StyledGradeBookLessonMiroImage = styled('img')({
	width: '20px',
	height: '20px',
	borderRadius: '4px',
});

export const StyledGradeBookLessonInfo = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'showTis',
})<{ showTis: boolean }>(({ showTis }) => ({
	display: 'flex',
	alignItems: 'center',
	overflow: 'hidden',
	zIndex: 1,

	...(showTis && {
		position: 'relative',
		'&::before': {
			content: '""',
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			backgroundImage: `url(${CanadaBackground})`,
			backgroundSize: 'cover',
			backgroundPosition: 'center',
			opacity: 0.2,
			zIndex: -1,
		},
	}),
}));

export const StyledGradeBookLessonOnlineText = styled(Typography)({
	display: 'block',
	marginRight: '4px',
});

export const StyledGradeBookLessonInfoNavigation = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '8px',
	marginLeft: 'auto',
});
